import React from "react";
import AnalyzerTypeManagement from "../components/analyzers/AnalyzerTypeManagement/AnalyzerTypeManagement";

const AnalyzerTypesPage = () => {
  return <AnalyzerTypeManagement />;
};

export default AnalyzerTypesPage;
